import type { ReactNode } from 'react';

import { Button } from '@shigo-ui/ui';

import { dashboardT } from '../../../../lib/messages';

export function ManagedSelectionSection({
  action,
  children,
  clearLabel,
  emptyText,
  manageLabel,
  onManage,
  onClear,
  selectedItems,
  title,
}: {
  action?: ReactNode | undefined;
  children?: ReactNode | undefined;
  clearLabel?: string | undefined;
  emptyText: string;
  manageLabel: string;
  onManage?: (() => void) | undefined;
  onClear: () => void;
  selectedItems: unknown[];
  title: string;
}) {
  const disabledDescriptionId = `${title.replace(/\s+/g, '-').toLowerCase()}-disabled-description`;

  return (
    <section className="border-border bg-card grid gap-4 rounded-md border p-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h3 className="text-foreground text-sm font-semibold">{title}</h3>
        <div className="flex flex-wrap items-center gap-3">
          <span className="text-muted-foreground text-xs">
            {dashboardT('common.item', { count: selectedItems.length })}
          </span>
          {action}
        </div>
      </div>
      {selectedItems.length ? (
        children
      ) : (
        <p className="text-muted-foreground text-sm">{emptyText}</p>
      )}
      <div className="flex flex-wrap gap-2">
        <Button
          type="button"
          variant="outline"
          className="rounded-full"
          disabled={!onManage}
          aria-describedby={onManage ? undefined : disabledDescriptionId}
          onClick={onManage}
        >
          {manageLabel}
        </Button>
        {!onManage ? (
          <span id={disabledDescriptionId} className="sr-only">
            {manageLabel} is not available in this phase.
          </span>
        ) : null}
        <Button
          type="button"
          variant="outline"
          className="rounded-full"
          disabled={!selectedItems.length}
          onClick={onClear}
        >
          {clearLabel ?? dashboardT('targeting.clearSelection', { title })}
        </Button>
      </div>
    </section>
  );
}
